import dayjs from 'dayjs';

import { Ticket } from '../../MessageList.interface';

import { CSAT_STATUS_ID, LAST_VIEWED_FIELD_ID } from 'services/help-center/constants';

function showUnreadNotification(ticket: Ticket, zdUser?: { id: number }): boolean {
    if (ticket.status === 'closed') {
        return false;
    }

    const lastComment = ticket.last_comment?.public ? ticket.last_comment : undefined;

    const lastViewedTimestamp = ticket.custom_fields?.find((field) => field.id === LAST_VIEWED_FIELD_ID)?.value;
    const lastMessage = lastComment?.created_at || ticket.updated_at || ticket.created_at;

    // If there is no last message, don't show notification
    if (!lastMessage || !lastComment) {
        return false;
    }

    // Ensure both dates are treated as UTC when comparing (saved as UTC in Zendesk)
    const lastMessageDate = dayjs(lastMessage).utc();
    const isLastMessageAfterLastViewed =
        lastViewedTimestamp && lastMessageDate.isAfter(dayjs(lastViewedTimestamp).utc());
    const isLastMessageByCustomer = lastComment?.author_id === zdUser?.id;

    const isShowingCSAT = ticket.status === 'solved' && ticket.custom_status_id === CSAT_STATUS_ID;

    // Show notification if:
    // 1. The last message is after the last viewed timestamp AND not authored by the customer, OR
    // 2. The ticket is showing CSAT survey (solved status with CSAT custom status)
    const showNotification = (isLastMessageAfterLastViewed && !isLastMessageByCustomer) || isShowingCSAT;

    return showNotification;
}

export default showUnreadNotification;
